import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=4765f2bd&scoped=true"
import script from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=4765f2bd&prod&lang=scss"
import style1 from "./WorkflowCard.vue?vue&type=style&index=1&id=4765f2bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765f2bd",
  null
  
)

export default component.exports